

import lazyLoadComponent from './lazyLoadComponent'
import { LoadingContent } from '@/components'

export default (component) => lazyLoadComponent({
  component,
  loading: LoadingContent,
  loadingData: {
    props: {
      loading: true,
      loadingLabel: 'Cargando...',
    },
  },
})



// WEBPACK FOOTER //
// ./src/utils/lazyComponent.js